/**
 * Utilidades centralizadas para manejo de fechas.
 * Elimina la duplicación de `new Date().toISOString()` en todo el codebase.
 */

const END_OF_DAY_HOURS = 23;
const END_OF_DAY_MINUTES = 59;
const END_OF_DAY_SECONDS = 59;
const END_OF_DAY_MS = 999;
const DATE_SLICE_LENGTH = 10;

/**
 * Obtiene la fecha/hora actual en formato ISO string.
 * Reemplaza el patrón repetido: `new Date().toISOString()`
 */
export function nowISO(): string {
  return new Date().toISOString();
}

/**
 * Obtiene el final del día actual (23:59:59.999) en formato ISO string.
 */
export function endOfTodayISO(): string {
  const d = new Date();
  d.setHours(END_OF_DAY_HOURS, END_OF_DAY_MINUTES, END_OF_DAY_SECONDS, END_OF_DAY_MS);
  return d.toISOString();
}

/**
 * Obtiene solo la parte de fecha (YYYY-MM-DD) de la fecha actual.
 *
 * OJO: es la fecha UTC (clave estable para dedupe/telemetría). Para fechas de
 * CALENDARIO que el usuario percibe (horarios, asistencia) usa `localDateKey`.
 */
export function todayDateKey(): string {
  return new Date().toISOString().slice(0, DATE_SLICE_LENGTH);
}

/**
 * Fecha LOCAL (YYYY-MM-DD) de un instante — la fecha que el usuario ve en su
 * reloj. `toISOString().slice(0,10)` devuelve la fecha UTC: en Venezuela
 * (UTC-4) a partir de las 20:00 ya es "mañana" en UTC (COV: el generador de
 * sesiones arrancaba en mañana y el pase de lista de HOY no encontraba su
 * sesión), y en husos UTC+ una medianoche local cae en "ayer".
 */
export function localDateKey(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
